var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3957_4303",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3957_4303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 8V4C13 3.71667 13.096 3.479 13.288 3.287C13.4793 3.09567 13.7167 3 14 3H20C20.2833 3 20.5207 3.09567 20.712 3.287C20.904 3.479 21 3.71667 21 4V8C21 8.28333 20.904 8.52067 20.712 8.712C20.5207 8.904 20.2833 9 20 9H14C13.7167 9 13.4793 8.904 13.288 8.712C13.096 8.52067 13 8.28333 13 8ZM3 12V4C3 3.71667 3.096 3.479 3.288 3.287C3.47933 3.09567 3.71667 3 4 3H10C10.2833 3 10.521 3.09567 10.713 3.287C10.9043 3.479 11 3.71667 11 4V12C11 12.2833 10.9043 12.5207 10.713 12.712C10.521 12.904 10.2833 13 10 13H4C3.71667 13 3.47933 12.904 3.288 12.712C3.096 12.5207 3 12.2833 3 12ZM13 20V12C13 11.7167 13.096 11.479 13.288 11.287C13.4793 11.0957 13.7167 11 14 11H20C20.2833 11 20.5207 11.0957 20.712 11.287C20.904 11.479 21 11.7167 21 12V20C21 20.2833 20.904 20.5207 20.712 20.712C20.5207 20.904 20.2833 21 20 21H14C13.7167 21 13.4793 20.904 13.288 20.712C13.096 20.5207 13 20.2833 13 20ZM3 20V16C3 15.7167 3.096 15.479 3.288 15.287C3.47933 15.0957 3.71667 15 4 15H10C10.2833 15 10.521 15.0957 10.713 15.287C10.9043 15.479 11 15.7167 11 16V20C11 20.2833 10.9043 20.5207 10.713 20.712C10.521 20.904 10.2833 21 10 21H4C3.71667 21 3.47933 20.904 3.288 20.712C3.096 20.5207 3 20.2833 3 20Z",
    fill: "black",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.befc69d51dbb9810e255a61f16bfeaec.svg";
export { ForwardRef as ReactComponent };